import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["track", "dot"]

  connect() {
    this.updateDots()
  }

  onScroll() {
    this.updateDots()
  }

  goTo(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    this.trackTarget.scrollTo({ left: index * this.trackTarget.clientWidth, behavior: "smooth" })
  }

  currentIndex() {
    if (this.trackTarget.clientWidth === 0) return 0
    return Math.round(this.trackTarget.scrollLeft / this.trackTarget.clientWidth)
  }

  updateDots() {
    const index = this.currentIndex()
    this.dotTargets.forEach((dot, i) => dot.classList.toggle("active", i === index))
    this.trackTarget.querySelectorAll(".pa-media-carousel-slide").forEach((slide, i) => {
      if (i !== index) slide.querySelectorAll("video").forEach((video) => video.pause())
    })
  }
}
